<template>
    <div v-if="config">
        <v-select v-model="config.countryCode" :items="countries" label="Country" />

        <v-label>Domains</v-label>
        <div style="margin-top:5px">
            <v-chip v-for="(t, i) in config.targets"
                    :key="i"
                    @click="edit(t, i)"
                    @click:close="remove(i)"
                    class="mr-2 mb-2"
                    close label
            >
                {{ t.domain }} ({{ t.filter.length }})
            </v-chip>
        </div>

        <v-row>
            <v-col cols="5">
                <v-text-field v-model="target.domain" :label="target.index === null ? 'Add domain' : 'Domain'" />
            </v-col>
            <v-col cols="7">
                <v-input>
                    <v-text-field v-model="target.filter" label="Filter (comma-separated)" />
                    <v-btn color="primary" @click="add()" icon>
                        <v-icon v-if="target.index === null">mdi-plus</v-icon>
                        <v-icon v-if="target.index !== null">mdi-content-save</v-icon>
                    </v-btn>
                </v-input>
            </v-col>
        </v-row>
    </div>
</template>

<script>
export default {
    props: ["config"],
    data: () => ({
        countries: [
            { value: "2756", text: "Switzerland" },
            { value: "2276", text: "Germany" },
            { value: "2250", text: "France" },
        ],
        target: {
            index: null
        }
    }),
    methods: {
        edit(t, i) {
            if (this.target.index === i)
                this.clear();
            else {
                this.target = {
                    index: i,
                    domain: t.domain,
                    filter: t.filter.join(",")
                };
            }
        },
        remove(i) {
            this.config.targets.splice(i, 1);
        },
        clear() {
            this.target.domain = "";
            this.target.filter = "";
            this.target.index = null;
        },
        add() {
            this.config.targets = this.config.targets || [];

            if (!this.target.domain)
                return;

            let newTarget = {
                "domain": this.target.domain,
                "filter": (this.target.filter || "").split(',').filter(s => s)
            };

            if (this.target.index !== null)
                this.config.targets.splice(this.target.index, 1, newTarget);
            else
                this.config.targets.push(newTarget);

            this.clear();
        }
    }
};
</script>